import React, { forwardRef } from "react";
import COLORS from "../../constants/colors";
import Flex from "../../layout/Flex";
import Radio from "../Radio/Radio";
import Typography from "../Typography";
import { StyledRadioGroupWrapper } from "./RadioGroup.styles";
import { RadioGroupProps } from "./RadioGroup.types";

const RadioGroup = forwardRef<HTMLInputElement, RadioGroupProps>(
    (props: RadioGroupProps, ref) => {
        const {
            groupDescription,
            groupLabel,
            name,
            onChange,
            option = [],
            value,
            descriptionColor,
            diskPosition,
            errorMsg,
            fillColor,
            labelColor,
            direction = "row",
            wrap = "",
            gap = 10,
            rowGap = props.gap,
            required,
            id,
            dividerNode,
        } = props;

        return (
            <StyledRadioGroupWrapper>
                <Typography size="m" required={required}>
                    {groupLabel}
                </Typography>
                <Typography size="sm">{groupDescription}</Typography>
                <Flex
                    flexWrap={wrap ? "wrap" : "initial"}
                    flexDirection={direction}
                    gap={gap}
                    style={{ rowGap: rowGap }}
                >
                    {option.map(({ id: optionId, ...restOption }, index) => {
                        return (
                            <>
                                <Radio
                                    id={id ? `${id}-${index}` : optionId}
                                    {...restOption}
                                    index={index}
                                    name={name}
                                    onChange={onChange}
                                    checked={value === restOption.value}
                                    fillColor={fillColor}
                                    labelColor={labelColor}
                                    descriptionColor={descriptionColor}
                                    diskPosition={diskPosition}
                                />
                                {index < option?.length - 1 && dividerNode}
                            </>
                        );
                    })}
                </Flex>
                <Typography color={COLORS.RED} size="sm">
                    {errorMsg}
                </Typography>
            </StyledRadioGroupWrapper>
        );
    },
);

export default RadioGroup;
